// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MeditateFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M48.003 27.035c-11.562 0-20.968 9.407-20.968 20.969 0 11.558 9.406 20.961 20.968 20.961 11.558 0 20.962-9.403 20.962-20.961 0-11.562-9.404-20.969-20.962-20.969m0 47.928c-14.869 0-26.966-12.094-26.966-26.959 0-14.869 12.097-26.967 26.966-26.967 14.866 0 26.96 12.098 26.96 26.967 0 14.865-12.094 26.959-26.96 26.959m0-60.463C29.53 14.5 14.5 29.53 14.5 48.007 14.5 66.475 29.53 81.5 48.004 81.5c18.47 0 33.496-15.025 33.496-33.493C81.5 29.53 66.474 14.5 48.004 14.5m0 73C26.222 87.5 8.5 69.783 8.5 48.007 8.5 26.223 26.222 8.5 48.004 8.5 69.782 8.5 87.5 26.223 87.5 48.007 87.5 69.783 69.782 87.5 48.004 87.5"
			fillRule="evenodd"
		/>
	</svg>
);
export default MeditateFilled;
